import { render, staticRenderFns } from "./ChangesLogs.vue?vue&type=template&id=df6da9b0&scoped=true"
import script from "./ChangesLogs.vue?vue&type=script&lang=js"
export * from "./ChangesLogs.vue?vue&type=script&lang=js"
import style0 from "./ChangesLogs.vue?vue&type=style&index=0&id=df6da9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6da9b0",
  null
  
)

export default component.exports